import { Link } from 'react-router-dom';
import Navbar from '@/pages/home/components/Navbar';
import Footer from '@/pages/home/components/Footer';
import FloatingButtons from '@/pages/home/components/FloatingButtons';
import ServicesSection from '@/pages/home/components/ServicesSection';

function HizmetlerHero() {
  return (
    <section className="relative pt-32 pb-20 bg-brand-navy overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="/media/search-image-11c8212785.jpg"
          alt="Hizmetlerimiz"
          className="w-full h-full object-cover object-top opacity-20"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-brand-navy via-brand-navy/90 to-brand-navy/70"></div>
      </div>
      <div className="relative max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center gap-2 mb-6">
          <a href="/" className="text-white/50 text-sm hover:text-white transition-colors cursor-pointer">Anasayfa</a>
          <span className="text-white/30 text-sm">/</span>
          <span className="text-brand-orange text-sm font-medium">Hizmetlerimiz</span>
        </div>
        <p className="text-brand-orange font-semibold text-sm uppercase tracking-widest mb-4">Hizmetlerimiz</p>
        <h1 className="text-white font-heading font-bold text-4xl md:text-5xl mb-6 leading-tight">
          Türkiye'den Avrupa'ya<br />
          <span className="text-brand-orange">Anahtar Teslim Lojistik</span>
        </h1>
        <p className="text-white/60 text-base md:text-lg max-w-xl leading-relaxed">
          Türkiye'nin 81 ilinden aldığımız eşyaları Avrupa'nın 27 ülkesine kapıdan kapıya teslim ediyoruz. Parsiyelden komple araca, ev taşımadan hızlı kargoya her ihtiyacınıza özel çözüm.
        </p>
      </div>
    </section>
  );
}

function HizmetlerCTA() {
  return (
    <section className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="bg-brand-navy rounded-2xl p-8 md:p-12 flex flex-col md:flex-row items-center justify-between gap-6">
          <div>
            <h3 className="text-white font-heading font-bold text-2xl md:text-3xl mb-3">
              Hangi Hizmete İhtiyacınız Var?
            </h3>
            <p className="text-white/60 text-sm md:text-base">
              Yük bilgilerinizi paylaşın, size en uygun çözümü 5 dakika içinde sunalım.
            </p>
          </div>
          <div className="flex flex-col sm:flex-row gap-3 flex-shrink-0">
            <a
              href="https://wa.me/905322376576?text=Merhaba%2C%20hizmetleriniz%20hakk%C4%B1nda%20bilgi%20almak%20istiyorum."
              target="_blank"
              rel="nofollow noreferrer"
              className="inline-flex items-center justify-center gap-2 bg-whatsapp hover:bg-whatsapp-dark text-white px-6 py-3 rounded-md text-sm font-semibold transition-all duration-200 cursor-pointer whitespace-nowrap"
            >
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-whatsapp-line text-base"></i>
              </span>
              WhatsApp ile Sor
            </a>
            <Link
              to="/iletisim"
              className="inline-flex items-center justify-center gap-2 bg-white/10 hover:bg-white/20 border border-white/20 text-white px-6 py-3 rounded-md text-sm font-semibold transition-all duration-200 cursor-pointer whitespace-nowrap"
            >
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-mail-send-line text-base"></i>
              </span>
              Form ile Ulaşın
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}

export default function HizmetlerimizPage() {
  return (
    <main className="font-sans">
      <Navbar />
      <HizmetlerHero />
      <ServicesSection />
      <HizmetlerCTA />
      <Footer />
      <FloatingButtons />
    </main>
  );
}
